import { useMemo, useState } from 'react';
import { useMount } from 'react-use';

import { Practitioner } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { FormController, Text, TextSeparator, TextSeparatorType, TextView } from '@dreryk/react-components';

import { SpecialtiesText } from '../../../../shared/specialties/SpecialtiesText';
import { medicalServiceTranslationKeys } from '../../../../translations';
import { MedicalServiceFormBean, MedicalServiceFormController } from '../../form/medicalServiceForm.types';
import { MedicalServicePractitionerBean } from '../practitioner.types';
import { mapPractitionerToMedicalServicePractitionerBean } from '../practitioner.utils';

type MedicalServicePractitionerFieldProps = Pick<MedicalServiceFormController, 'control' | 'register'> & {
   readonly practitioners: Practitioner[];
};

export const MedicalServicePractitionerField = (props: MedicalServicePractitionerFieldProps): JSX.Element => {
   const [practitioner, setPractitioner] = useState<MedicalServicePractitionerBean | undefined>(undefined);

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
      };
   }, []);

   useMount(() => {
      const deps: MedicalServiceFormBean = props.control.getValues();
      const value: MedicalServicePractitionerBean[] = props.practitioners.map(
         mapPractitionerToMedicalServicePractitionerBean(deps)
      );

      props.control.setValue('practitioners', value);
      setPractitioner(value.at(0));
   });

   return (
      <>
         <FormController controller={props.register('practitioners', validationRules)} />
         <TextView testId={'practitioner'} label={medicalServiceTranslationKeys.shared.practitioner.field.label}>
            {practitioner ? (
               <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
                  <Text testId={'displayName'}>{practitioner.displayName}</Text>
                  <SpecialtiesText specialties={practitioner.specialties} />
               </TextSeparator>
            ) : null}
         </TextView>
      </>
   );
};
